module.exports = function () {
    return {
        restrict: 'E',
        scope: {},
        template: require('./signup-navigation-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/signup-navigation-directive.js
 **/